// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const SecurityCriticalIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="SecurityCriticalIcon" ref={forwardedRef} {...props}>
      <path d="m7.5 10.619 3.5-5-.545 3.5L12.5 9.123 9 14.119l.614-3.5z" />
      <path d="M16.5 4.764v7.048a5 5 0 0 1-2.916 4.546L10 18l-3.584-1.642A5 5 0 0 1 3.5 11.812V4.764a1 1 0 0 1 .835-.987l1.97-.328a3 3 0 0 0 .849-.276L10 1.75l2.443 1.222a6 6 0 0 0 1.696.551l1.525.254A1 1 0 0 1 16.5 4.764m-9.458 10.23 2.959 1.356 2.958-1.356A3.5 3.5 0 0 0 15 11.812V5.187l-1.107-.184a7.5 7.5 0 0 1-2.12-.69L10 3.427 7.826 4.515a4.5 4.5 0 0 1-1.273.414L5 5.187v6.625a3.5 3.5 0 0 0 2.041 3.182" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const SecurityCriticalIcon = /* @__PURE__ */ Object.assign(
  SecurityCriticalIconComponent,
  { displayName: 'SecurityCriticalIcon' },
);
